import React, { useContext, useEffect, useState } from "react";
import { CircularProgress, Tab, Tabs } from "@mui/material";
import { BaseModal } from "../../common/Modal/BaseModal";
import { AccountIntegrityTab } from "./AccountIntegrityTab/AccountIntegrityTab";
import { AccountPharmaciesTab } from "./AccountPharmaciesTab";
import { PurchaseValidationContext } from "../PurchaseValidationContext";
import { Close } from "@mui/icons-material";
import { humanizeText } from "../../utils/StringFormatters";
import { useSearchParams } from "../../Hooks/useSearchParams";
import MixpanelService from "../../utils/MixpanelService";
import { formatPharmacyGroupName } from "../../utils/Helpers";
import { AccountTransactionsTab } from "./AccountTransactionsTab/AccountTransactionsTab";

export const AccountModal = () => {
  const {
    coveredEntity340bId,
    manufacturers,
    coveredEntityNames,
    hasFetchedAccounts,
    accountModal,
    setAccountModal,
    accounts,
  } = useContext(PurchaseValidationContext);

  const [searchParams, setSearchParams] = useSearchParams();
  const [tab, setTab] = useState(searchParams["account_tab"] ?? "integrity");

  const account = accounts.find((acc) => acc.id === accountModal?.accountId);
  const manufacturer = manufacturers.find((m) => m.value === account?.manufacturer)?.label;

  const closeModal = () => {
    setTab("integrity");
    setAccountModal(undefined);
    setSearchParams({ ...searchParams, account_id: undefined, account_tab: undefined });
  };

  const handleTabChange = (e, newValue) => {
    // esp_horizon_ad_compliance, esp_horizon_ad_pharmacies, etc
    MixpanelService.track(`esp_horizon_ad_${newValue}`);

    setTab(newValue);
    setSearchParams({
      ...searchParams,
      account_tab: newValue,
    });
  };

  return (
    <BaseModal
      open={!!accountModal}
      onClose={closeModal}
      className="modal-end modal-scroll account-modal"
      height="100%"
    >
      <div>
        <div className="pt-4 px-4">
          <div className="t--lg flex align-items-center justify-content-between">
            <div className="page-details__title">Account Details</div>
            <button
              className="button button--white border--rounded w--32 h--32"
              onClick={closeModal}
            >
              <Close sx={{ fontSize: 16 }} />
            </button>
          </div>

          <div className="pb-3 t--500" style={{ fontSize: 18 }}>
            {coveredEntityNames[coveredEntity340bId]}
            {account?.group_name
              ? " - " + formatPharmacyGroupName(account.group_name).toUpperCase()
              : ""}
          </div>
          <div className="flex gap--16 pb-3">
            <div className="account-chip">{coveredEntity340bId}</div>
            {manufacturer ? <div className="account-chip">{manufacturer}</div> : null}
            {account?.network ? <div className="account-chip">{account?.network}</div> : null}
          </div>
        </div>
        <div className="w--full px--24 border--bottom">
          <Tabs value={tab} onChange={handleTabChange}>
            <Tab label="Integrity" value="integrity" />
            <Tab
              label={
                <div className="flex align-items-center">
                  Pharmacies
                  <div className="pharmacy-num ml-2">{account?.pharmacy_count ?? "-"}</div>
                </div>
              }
              value="pharmacies"
            />
            <Tab label="All Transactions" value="transactions" />
          </Tabs>
        </div>
        {account ? (
          <>
            {tab === "integrity" ? <AccountIntegrityTab /> : null}
            {tab === "pharmacies" ? <AccountPharmaciesTab /> : null}
            {tab === "transactions" ? <AccountTransactionsTab /> : null}
          </>
        ) : (
          <div className="p-4">
            {hasFetchedAccounts ? (
              <div>This account is no longer found.</div>
            ) : (
              <CircularProgress />
            )}
          </div>
        )}
      </div>
    </BaseModal>
  );
};
